import React, { useState } from "react"
import propTypes from "prop-types"
import { Button } from "reactstrap"
import Swal from "sweetalert2"
import { getTicket, deleteTicket } from "services/tickets"
import { useHistory } from "react-router"
import { useQueryClient, useMutation } from "@tanstack/react-query"
import { lenguage, dateConfig } from "config/format-date"

const PendingSalesItemList = ({ item }) => {
  const [isHovered, setIsHovered] = useState(false)
  const date = new Date(item.date.replace("Z", ""))
  const formattedDate = date.toLocaleString(lenguage, dateConfig)
  const history = useHistory()
  const styleCenterTable = { textAlign: "center", verticalAlign: "middle" }
  const rowStyle = isHovered ? { backgroundColor: "#E3F3D5" } : undefined
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer)
      toast.addEventListener("mouseleave", Swal.resumeTimer)
    },
  })

  function currencyFormatter({ currency, value }) {
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      minimumFractionDigits: 2,
      currency,
    })
    return formatter.format(value)
  }

  const handleOnClickSale = () => {
    getTicket(item.id).then((ticket) => {
      history.push(`sale/${ticket.id}`)
    })
  }
  const queryClient = useQueryClient()

  const deleteMutation = useMutation((id) => deleteTicket(id), {
    onSuccess: () => {
      queryClient.invalidateQueries(["pendingTickets"])
      queryClient.invalidateQueries(["ticketsNoPaid"])
      history.replace("/sale")
      Toast.fire({
        icon: "error",
        title: "Venta eliminada con exito",
      })
    },
    onError: (_err) => {
      Toast.fire({
        icon: "error",
        title: "Error al eliminar",
      })
    },
  })

  const handleOnClickCancel = (id) => {
    deleteMutation.mutate(id)
  }

  return (
    <tr
      key={item.id}
      style={rowStyle}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <td style={{ ...styleCenterTable, backgroundColor: isHovered ? "#E3F3D5" : undefined }}>{item.folio}</td>
      <td style={{ ...styleCenterTable, backgroundColor: isHovered ? "#E3F3D5" : undefined }}>
        {formattedDate}
      </td>
      <td style={{ ...styleCenterTable, backgroundColor: isHovered ? "#E3F3D5" : undefined }}>
        {item?.user?.first_name} {item?.user?.last_name}
      </td>
      <td style={{ ...styleCenterTable, backgroundColor: isHovered ? "#E3F3D5" : undefined }}>
        {item?.customer?.name}
      </td>
      <td style={{ ...styleCenterTable, backgroundColor: isHovered ? "#E3F3D5" : undefined }}>
        {currencyFormatter({ currency: "USD", value: item.total })}
      </td>
      <td style={{ ...styleCenterTable, backgroundColor: isHovered ? "#E3F3D5" : undefined }}>
        <Button color="primary" title="Continuar venta" onClick={handleOnClickSale}>
          <i className="fa fa-dollar-sign" />
        </Button>
        <Button
          style={{ marginLeft: "10px" }}
          color="danger"
          title="Eliminar venta"
          onClick={() => handleOnClickCancel(item.id)}
        >
          <i className="fa fa-trash" />
        </Button>
      </td>
    </tr>
  )
}

PendingSalesItemList.propTypes = {
  item: propTypes.object,
}

export default PendingSalesItemList
